// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1K35u","head":"ProcedureTableInfo_head__3KT1b"};